<template>
    <b-modal id="resource-booking-checkout"
        v-model="bookingModalIsOpen"
        size="md"
        centered

        footerClass='justify-content-start'
        :hide-header="true"
        :hide-footer="false"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :hide-header-close="true" >

        <template v-slot:modal-header>
            <h5 class="modal-title text-center font-weight-bold">Paga con carta di credito</h5>
        </template>

        <div class="default">
            <div class="row">
                <div class="col">
                    <div class="alert alert-info">
                        <div class="form-group row" v-if="resource">
                            <div class="col-2 pr-2 text-center">
                                <img class="card-img rounded" :src="getImageSrc" />
                            </div>
                            <div class="col-10 pl-2">
                                <h5 pb-0>{{ resource.name }}</h5>
                                <h6>{{ resource.title ? `Specializzazione in ${resource.title}` : '' }}</h6>
                            </div>
                        </div>
                        <hr />
                        <div class="form-group row" v-if="service">
                            <div class="col-2 pr-2 text-center">
                                <i class="far fa-hand-holding-medical" style="font-size:1.5em;"></i>
                            </div>
                            <div class="col-10 pl-2">
                                <div>{{ service.name }}</div>
                            </div>
                        </div>
                        <hr />
                        <div class="form-group row mb-2" v-if="service">
                            <div class="col-2 pr-2 text-center">
                                <i class="far fa-money-bill-wave" style="font-size:1.5em;"></i>
                            </div>
                            <div class="col-10 pl-2">
                                <div>{{ service.price+" €" + (service.bookingPrice != service.price ? " (caparra: "+service.bookingPrice+" €)" : "") }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-row">
                        <div class="form-group col">
                            <label for="email">{{ $t('user.email') }}</label>
                            <input id="email" type="text" class="form-control" v-model="user.email" disabled>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col">
                            <label for="stripe-card">{{ $t('user.card_info') }} <span class="text-danger">*</span></label>
                            <card class='stripe-card form-control w-100'
                                :class='{ complete }'
                                :stripe='stripeKey'
                                :stripeOptions='stripeOptions'
                                :options='stripeCardOptions'
                                ref='stripeCard'
                                @change='complete = $event.complete'
                            />
                        </div>
                    </div>
                    <div v-if="checkoutNote" class="alert alert-danger" :inner-html.prop="checkoutNote | nl2br"></div>
                    <div class="form-row">
                        <div class="form-group col">
                            <img src="/public/img/powered_by_stripe.png" height="26">
                            <span class="divider text-muted px-2 d-none d-sm-inline">|</span>
                            <a href="https://stripe.com/it/privacy" target="_blank">Privacy Stripe</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-slot:modal-footer>
            <div>
                <b-button v-on:click="pay" variant="link" class="btn-primary" :disabled='!complete'>{{ getPayButtonLabel }}</b-button>
            </div>
            <div class="divider"></div>
            <div>
                <b-button v-on:click="cancel" variant="link" class="btn-default">Annulla</b-button>
            </div>
            <div class="divider"></div>
        </template>
    </b-modal>
</template>

<script>
import VueTypes from 'vue-types'
import { Card, instance as stripe } from 'vue-stripe-elements-plus'

export default {
    components: {
        Card,
    },
    data() {
        let stripeOptions = {};
        if (stripeConnectAccountId) {
            stripeOptions['stripeAccount'] = stripeConnectAccountId;
            stripeOptions['locale'] = locale;
            // stripeOptions['apiVersion'] = '3';
        }

        return {
            complete: false,
            stripeKey: stripe_public_key,
            stripeOptions: stripeOptions,
            stripeCardOptions: {
                'hidePostalCode': true,
                'style': {
                    base: {
                        color: '#32325d',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        lineHeight: '24px',
                        '::placeholder': {
                            color: '#aab7c4'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                },
            },
        };
    },
    props: {
        stripeClientSecret: VueTypes.string.def(undefined),
        resource: VueTypes.object,
        service: VueTypes.object,
        user: VueTypes.object,
        checkoutNote: VueTypes.string,
    },
    computed: {
        bookingModalIsOpen() {
            if (this.stripeClientSecret) {
                return true;
            }
            return false;
        },
        getImageSrc() {
            return (this.resource && this.resource.imageUrl) || defaultProfileImage;
        },
        getPayButtonLabel() {
            if (this.service.bookingPrice == this.service.price) {
                return "Paga " + this.service.bookingPrice + " €";
            } else {
                return "Paga la caparra di "  +this.service.bookingPrice + " €";
            }
        },
    },
    filters: {
        properCase(string) {
            if (typeof string == "string") {
                return string.charAt(0).toUpperCase() + string.slice(1);
            } else {
                return "";
            }
        },
    },
    methods: {
        pay() {
            this.$emit('setLoadingPaymentConfirm', true);
            let thisComponent = this;
            var cardElement = this.$refs.stripeCard.$refs.element._element;

            stripe.confirmCardPayment(this.stripeClientSecret, {
                payment_method: {
                    card: cardElement,
                    billing_details: {
                        name: this.user.full_name,
                        email: this.user.email,
                        phone: this.user.mobile_phone,
                        address: {
                            country: this.user.country_code,
                            state: this.user.area,
                            city: this.user.city,
                            line1: this.user.address,
                            postal_code: this.user.postal_code,
                        },
                    }
                }
            }).then((result) => {
                if (result.error) {
                    // Show error to your customer (e.g., insufficient funds)
                    switch (result.error.code) {
                        case 'payment_intent_unexpected_state':
                            thisComponent.$snotify.error("Il tempo massimo per la transazione è scaduto o è stata avviata una nuova transazione, si prega di riprovare ad effettuare la prenotazione");
                            thisComponent.cancel();
                            break;
                        default:
                            var errorMessage = result.error.message;

                            // Durata dinamica del popup
                            var dynamicTimeout = 6000;
                            let textWords = errorMessage.split(' ').length;
                            dynamicTimeout = Math.max(dynamicTimeout, textWords * 250);

                            thisComponent.$snotify.error(errorMessage, {
                                timeout: dynamicTimeout,
                            });
                            break;
                    }
                    this.$emit('setLoadingPaymentConfirm', false);
                    return;
                }
                console.log(result.paymentIntent);
                if (!result.paymentIntent || result.paymentIntent.status != 'succeeded') {
                    thisComponent.$snotify.error("Errore sconosciuto, si prega di riprovare");
                    this.$emit('setLoadingPaymentConfirm', false);
                    return;
                }
                window.location.href = "/checkout/success";
            });
        },
        cancel() {
            console.log("cancel");
            this.$emit('closeCheckoutDialog');
        }
    },
};
</script>

<style>
.stripe-card {
    margin: 0 auto;
}
</style>
